/*---------------------------------------------------------------------------------------------
* Copyright (c) Bentley Systems, Incorporated. All rights reserved.
* See LICENSE.md in the project root for license terms and full copyright notice.
*--------------------------------------------------------------------------------------------*/

export * from "./ITwinLocalization";

/** @docs-package-description
 * The core-i18n package contains classes related to internationalization and localization.
 */

/** @docs-group-description Localization
 * Classes for internationalization and localization of your app.
 */
